import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Silent JWT refresh on 401 — one retry, then bubble up
let refreshInFlight = null;
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config || {};
    const status = err.response?.status;
    // Skip if not 401, or this is the refresh call itself, or we already retried
    if (
      status !== 401 ||
      original.__isRetry ||
      (original.url || "").includes("/auth/refresh") ||
      (original.url || "").includes("/auth/login") ||
      (original.url || "").includes("/auth/register")
    ) {
      return Promise.reject(err);
    }
    try {
      if (!refreshInFlight) {
        refreshInFlight = api.post("/auth/refresh").finally(() => {
          refreshInFlight = null;
        });
      }
      await refreshInFlight;
      original.__isRetry = true;
      return api(original);
    } catch {
      return Promise.reject(err);
    }
  }
);

export const SUBJECTS = [
  "Mathematics", "Science", "Physics", "Chemistry", "Biology",
  "English", "Social Studies", "Computer Science", "Hindi", "History",
];

export const CLASSES = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

export const BOARDS = ["CBSE", "ICSE", "State Board", "IB", "IGCSE", "Other"];

export const STATES_INDIA = [
  "Andhra Pradesh", "Delhi", "Gujarat", "Karnataka", "Kerala",
  "Maharashtra", "Punjab", "Rajasthan", "Tamil Nadu", "Telangana",
  "Uttar Pradesh", "West Bengal", "Other",
];

export const LANGUAGES = ["English", "Hindi", "Bengali", "Marathi", "Telugu", "Tamil", "Gujarati", "Kannada", "Malayalam", "Punjabi"];

export const TEACHING_MODES = ["online", "offline", "hybrid"];

export const PREP_OPTIONS = [
  "School Board (CBSE)", "School Board (ICSE)", "State Board",
  "JEE Main / Advanced", "NEET", "Olympiad", "SAT", "IB / IGCSE", "Regular Study",
];
